<template>
  <div class="flex justify-center app-content-back w-screen mt-0 align-top min-h-screen pt-4">
    <div class="container mx-auto">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
    name: 'TeamsLayout'
}
</script>

<style scoped>

</style>